import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router';

import { invalidatePatientOverviewData } from '@/services/patientOverviewData';

export default function useBillingPeriodService() {
  const queryClient = useQueryClient();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const toggleAction = useMutation({
    mutationFn: async ({
      data,
      inValidateQuery,
    }: {
      data: { startDate?: string; endDate?: string };
      inValidateQuery?: boolean;
    }) => {
      await axios.post(
        `/api/camel/patient_profile/administration/${patientUuid}/billing_period/current`,
        data,
      );
      if (inValidateQuery) {
        invalidateAdministrationQuery();
      }
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['camel', 'patient_profile', 'configuration', patientUuid],
        }),
        invalidatePatientOverviewData(queryClient, patientUuid),
      ]);
    },
  });

  const invalidateAdministrationQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patient_profile', 'administration', patientUuid],
    });
  };

  return {
    toggleBillingPeriod: toggleAction.mutateAsync,
  };
}
